import React from 'react';
import { Tabs } from '@facet-wealth/design';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import useMobileLayout from 'Hooks/useMobileLayout';
import Select from 'Components/ComponentLibrary/Atoms/Inputs/Select';
import {
  useManagedAccountPageContext,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Context/ManagedAccountPageContext';

const CollectionTabs = ({
  collection,
  onChange,
  value,
}) => {
  const { currentTab } = useManagedAccountPageContext();
  const options = collection.resources().list().map(res => {
    return {
      value: res.attr('name'),
      label: res.meta().field('name').attr('prompt'),
    };
  });
  const isMobile = useMobileLayout();

  if (isMobile) {
    const selectOptions = collection.resources().list().map(res => {
      return {
        value: res.attr('name'),
        name: res.meta().field('name').attr('prompt'),
      };
    });
    return (
      <Select
        color="white"
        key="facet-plan-chart-time-select"
        onChange={(e) => onChange(e, e.value)}
        options={selectOptions}
        value={currentTab}
        variant="contained"
      />
    );
  }

  return (
    <Tabs.Horizontal
      onChange={onChange}
      options={options}
      value={value}
    />
  );
};

CollectionTabs.defaultProps = {
  onChange: noop,
  value: '',
};

CollectionTabs.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default CollectionTabs;
